import { Box, Typography, Stack, Divider } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CodeIcon from "@mui/icons-material/Code";
import GitHubIcon from "@mui/icons-material/GitHub";
import CallSplitIcon from "@mui/icons-material/CallSplit"; // For Forks

export default function EngagementCard() {
  return (
    <Box
      sx={{
        p: 3,
        borderRadius: 3,
        background: "rgba(255,255,255,0.02)",
        border: "1px solid rgba(255,255,255,0.06)",
        backdropFilter: "blur(10px)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        {/* Title & Github Icon */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2, color: "text.heading" }}>
          <Typography variant="h1" >
            Engagement & Feedback
          </Typography>
          <GitHubIcon  sx={{  fontSize: "icon.size", color: "icon.main", opacity: 0.4 }} />
        </Stack>

        {/* Quick Git Stats Row */}
        <Stack direction="row" spacing={3} sx={{ mb: 3 }}>
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>1.2k</Typography>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ opacity: 0.5 }}>
              <StarIcon sx={{ fontSize: 12 }} />
              <Typography variant="caption">Stars</Typography>
            </Stack>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>340</Typography>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ opacity: 0.5 }}>
              <CallSplitIcon sx={{ fontSize: 12 }} />
              <Typography variant="caption">Forks</Typography>
            </Stack>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 18, fontWeight: 700 }}>98%</Typography>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ opacity: 0.5 }}>
              <CodeIcon sx={{ fontSize: 12 }} />
              <Typography variant="caption">Uptime</Typography>
            </Stack>
          </Box>
        </Stack>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.05)", mb: 2 }} />

        {/* Status Indicators */}
        <Stack spacing={1.5} sx={{ mb: 4 }}>
          <MetricRow icon={<VisibilityIcon sx={{ fontSize: 14 }} />} label="Live Demo Visits" value="Active" color="#4caf50" />
          <MetricRow icon={<CodeIcon sx={{ fontSize: 14 }} />} label="Recent Commits" value="Daily" color="#03a9f4" />
        </Stack>
      </Box>

      {/* Testimonial Section */}
      <Box>
        <Typography sx={{ fontStyle: "italic", opacity: 0.8, fontSize: 13, lineHeight: 1.6 }}>
          “Strong focus on both functionality and security — rare combination.”
        </Typography>
        <Typography sx={{ mt: 1, fontSize: 11, opacity: 0.4, fontWeight: 600, textTransform: "uppercase" }}>
          — Senior Security Engineer
        </Typography>
      </Box>
    </Box>
  );
}

// Reusable row component for the small metrics
function MetricRow({ icon, label, value, color }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" spacing={1} sx={{ opacity: 0.7 }}>
        {icon}
        <Typography sx={{ fontSize: 13 }}>{label}</Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: color, boxShadow: `0 0 8px ${color}` }} />
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{value}</Typography>
      </Stack>
    </Stack>
  );
}

